module.exports = __webpack_public_path__ + "static/media/loc1_img25.3477e6b4.jpg";